import { FunctionComponent, useMemo } from "react";

import styles from "./CardRadioGroup.module.scss";

type Props = {
  radios: any;
  value?: string | number;
  onChange?: (e: React.FormEvent<HTMLInputElement>, option?: any) => void;
  name: string;
  renderContent: any;
  errorMsg?: string;
  optionClassName?: string;
  wrapperClassName?: string;
  onClickSelected?: () => void;
};

export const CardRadioGroup: FunctionComponent<Props> = ({
  radios,
  value = "",
  onChange,
  name,
  renderContent,
  errorMsg = "",
  wrapperClassName = "",
  optionClassName = "",
  onClickSelected = () => {},
}) => {
  const options = useMemo(() => {
    return radios.map((option: any) => {
      return {
        ...option,
      };
    });
  }, [radios]);

  return (
    <>
      <div className={`flex ${wrapperClassName}`}>
        {options &&
          options.map((option: { value?: string; name: string }) => {
            const isSelected = option.value == value || option.name == value;
            const id = option.name || `${name}-${option.value}`;
            return (
              <div
                className={`rounded border border-solid ${optionClassName} ${
                  isSelected ? "border-success" : "border-transparent"
                }`}
                key={option.name + option.value}
              >
                <input
                  type="radio"
                  name={name}
                  id={id}
                  onClick={(e) => {
                    if (isSelected) {
                      onClickSelected();
                    } else {
                      onChange && onChange(e, option);
                    }
                  }}
                  value={option.value || option.name}
                  className="invisible h-0 absolute"
                />
                <label htmlFor={id} className="cursor-pointer">
                  {renderContent(option)}
                </label>
              </div>
            );
          })}
      </div>
      {<p className={styles.errorMsg}>{errorMsg ? errorMsg : ""}</p>}
    </>
  );
};
